import * as THREE from 'three';

export class LightingRig {
  readonly group = new THREE.Group();
  private basementLights: THREE.Light[] = [];
  private hiddenLights: THREE.Light[] = [];
  private mainLights: THREE.Light[] = [];

  constructor() {
    // 環境（暗すぎ防止のベース照度）
    const hemi = new THREE.HemisphereLight(0xd0d8e8, 0x3a3028, 0.55);
    this.group.add(hemi);
    this.mainLights.push(hemi);

    const ambient = new THREE.AmbientLight(0x606870, 0.45);
    this.group.add(ambient);

    // エントランス
    this.addPoint(0, 2.8, 0, 0xffd0a0, 18, 16, true);
    this.addPoint(0, 1.5, -2, 0xffe0c0, 6, 8, false);
    // リビング
    this.addPoint(9, 2.6, 0, 0xffc890, 20, 18, true);
    this.addPoint(12, 1.5, 2, 0xffaa66, 8, 9, false);
    this.addPoint(7, 2.2, -2, 0xffd0a0, 8, 10, false);
    // 書斎
    this.addPoint(9, 2.5, 9, 0xe8d0b0, 16, 15, true);
    this.addPoint(7, 1.4, 9, 0xffcc88, 5, 7, false);
    // キッチン
    this.addPoint(0, 2.6, 8, 0xf0e8d8, 16, 14, true);
    this.addPoint(1, 1.8, 10, 0xffffff, 6, 8, false);
    // ダイニング
    this.addPoint(18, 2.5, 0, 0xffd0a8, 14, 12, true);
    this.addPoint(18, 1.3, 0, 0xffcc88, 5, 6, false);
    // 地下室（暗め・復旧で明るく）
    const b1 = this.addPoint(-9, 2.2, 0, 0x88aacc, 3, 12, false);
    const b2 = this.addPoint(-11, 1.5, -1, 0xff8844, 2, 7, false);
    const b3 = this.addPoint(-7, 2.0, 1, 0x6688aa, 2, 8, false);
    this.basementLights.push(b1, b2, b3);
    // 隠し部屋
    const h1 = this.addPoint(-9, 2.4, 8, 0xa090ff, 4, 12, false);
    const h2 = this.addPoint(-12, 2.0, 8, 0xffcc88, 3, 9, false);
    this.hiddenLights.push(h1, h2);

    // 定向キーライト（影）
    const dir = new THREE.DirectionalLight(0xffe8d0, 0.7);
    dir.position.set(8, 14, 6);
    dir.castShadow = true;
    dir.shadow.mapSize.set(2048, 2048);
    dir.shadow.camera.near = 1;
    dir.shadow.camera.far = 40;
    dir.shadow.camera.left = -24;
    dir.shadow.camera.right = 28;
    dir.shadow.camera.top = 24;
    dir.shadow.camera.bottom = -24;
    dir.shadow.bias = -0.0003;
    this.group.add(dir);
    this.mainLights.push(dir);
  }

  private addPoint(
    x: number,
    y: number,
    z: number,
    color: number,
    intensity: number,
    distance: number,
    castShadow: boolean,
  ): THREE.PointLight {
    const l = new THREE.PointLight(color, intensity, distance, 2);
    l.position.set(x, y, z);
    if (castShadow) {
      l.castShadow = true;
      l.shadow.mapSize.set(512, 512);
      l.shadow.bias = -0.001;
    }
    this.group.add(l);
    return l;
  }

  setBasementPower(on: boolean): void {
    for (const l of this.basementLights) {
      if (l instanceof THREE.PointLight) {
        l.intensity = on ? 14 : 2.5;
      }
    }
  }

  setHiddenLit(on: boolean): void {
    for (const l of this.hiddenLights) {
      if (l instanceof THREE.PointLight) {
        l.intensity = on ? 16 : 3.5;
      }
    }
  }
}
